module.exports = {
  address: "0xD313E8C397528b5Cfa26718E2b2D3Dd0a3A67427",
  address_test: '0xd2f5eB0cAd53103e13a83aAD834b08e0E92eC0a4',
  abi: require('./Claim.abi.json')
}
